import { Directive, HostListener, ElementRef } from '@angular/core';
import { UtilityService } from 'src/app/service/utility.service';

@Directive({
  selector: '[appOnlyLetters]'
})
export class OnlyLettersDirective {

  //constructor(private el: ElementRef) { }

  //@HostListener('input', ['$event']) onInputChange(event: any) {
  //  const initalValue = this.el.nativeElement.value;
  //  this.el.nativeElement.value = initalValue.replace(/[^a-zA-Z- \s]*/g, '');
  //  if ( initalValue !== this.el.nativeElement.value) {
  //    event.stopPropagation();
  //  }
  //}

  constructor(private utilityService: UtilityService) {}
  private pattern = /[A-Za-z\- ]/;

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {

    if (e.key) {
      const inputChar = e.key.toString();

      if (!this.pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
        e.preventDefault();
      }
    }
  }
}